
import * as api from "../constant/NewAPI";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import Utils from "../constant/Utils";

// import * as api from "../constant/API";

const VideoTut = () => {

    const [sportId, setSportId] = useState('');
    const [sportsList, setSportList] = useState([]);
    const [videoList, setVideoList] = useState([]);
    const [videoName, setVideoName] = useState('');
    const [videoUrl, setVideoUrl] = useState('');
    const [showVideo, setShowVideo] = useState(false);

    useEffect(() => {
        getSportsList()
    }, [])

    function getSportsList() {
        const sprtlst = api.SportList;
        fetch(sprtlst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sprtResponse) => sprtResponse.json())
            .then((sprtResult) => {
                if (sprtResult.error == true) {
                    if (sprtResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    setSportList(sprtResult.data)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch sports list", error);
            })
    }

    function listVideo(sprtid) {
        const vdolst = api.VideoNameBySport + '/' + sprtid //"?sportId=" + sprtid;
        fetch(vdolst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((vdoResponse) => vdoResponse.json())
            .then((vdoResult) => {
                if (vdoResult.error == true) {
                    if (vdoResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (vdoResult.data != null) {
                        setVideoList(vdoResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch video list", error);
            })
    }

    function playVideo(vname) {
        const url = "https://www.tenvicsports.com/videos/" + vname;
        setVideoUrl(url);
        setShowVideo(true);
    }
    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center">
                                                        <div className="row col-lg-12">
                                                            <div className="col-lg-12"></div>
                                                            <div className="row col-lg-12 court-sortby sortbyset">
                                                                <div className="col-lg-6">
                                                                    <div className="mb-10">
                                                                        <label className="sortbytitle"><h6>Sport</h6></label>
                                                                        <Select
                                                                            value={sportsList.find(sprt => sprt.sportId === sportId) ? {
                                                                                value: sportId,
                                                                                label: sportsList.find(sprt => sprt.sportId === sportId).sportName
                                                                            } : null}
                                                                            onChange={(e) => {
                                                                                setSportId(e.value);
                                                                                listVideo(e.value)
                                                                            }}
                                                                            options={sportsList.map(sprt => ({
                                                                                value: sprt.sportId,
                                                                                label: sprt.sportName
                                                                            }))}>
                                                                        </Select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-6">
                                                                    <div className="mb-10">
                                                                        <label className="sortbytitle"><h6>Video</h6></label>
                                                                        <Select value={videoList.find(vdo => vdo.videoFilename === videoName) ? {
                                                                            value: videoName,
                                                                            label: videoList.find(vdo => vdo.videoFilename === videoName).videoTitle
                                                                        } : null}
                                                                            onChange={(e) => {
                                                                                setVideoName(e.value);
                                                                                playVideo(e.value)
                                                                            }}
                                                                            options={videoList.map(vdo => ({
                                                                                value: vdo.videoFilename,
                                                                                label: vdo.videoTitle
                                                                            }))}
                                                                            placeholder={"Select Video"}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {showVideo && (
                                                                <div className="container">
                                                                    <div className="profile-info-box">
                                                                        <div className="badminton-img" style={{ margin: "0px" }}>
                                                                            <iframe
                                                                                height={420}
                                                                                src={videoUrl}
                                                                                title="video player"
                                                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                                                allowFullScreen=""
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

};

export default VideoTut;